import Learning from './Learning.container';

export default Learning;
